import { DeleteOutlined } from '@ant-design/icons';
import { Popconfirm } from 'antd';
import React from 'react';
import { Props } from '.';
import CapSelector from '../../../../components/cap-selector/CapSelector';
import Icon from '../../../../components/icon/Icon';
import { CapNumber } from '../../../../core/models/CapNumber';
import { getFieldPlayIneligibleCapNumbers, getTeamId } from '../../../../helpers/EventHelper';
import {
    CreateMatchPlayerCommandOfMatchPlayer,
    EventVm,
    GoalkeeperChangeRequest,
    UpdateEventCommand,
} from '../../../../utils/api';

class GoalkeeperChange extends React.PureComponent<Props> {
    public handleNewGoalkeeperSelect = (cap: number): void => {
        const { event, updateEvent, lineups } = this.props;

        const teamId = getTeamId(event);
        const teamLineups = lineups.filter(
            (l: CreateMatchPlayerCommandOfMatchPlayer): boolean => l.teamId === teamId
        );
        const lineup = teamLineups.find(
            (l: CreateMatchPlayerCommandOfMatchPlayer): boolean => l.number === cap
        );

        if (!lineup) return;

        const updatedEvent = new UpdateEventCommand({
            ...event,
            goalkeeperChange: new GoalkeeperChangeRequest({
                id: event.goalkeeperChange?.id || 0,
                teamId: teamId || 0,
                newGoalkeeperMatchPlayerId: lineup.id,
                previousGoalkeeperMatchPlayerId:
                    event.goalkeeperChange?.previousGoalkeeperMatchPlayerId,
            }),
        });

        updatedEvent.id = event.id;
        updateEvent(updatedEvent);
    };

    public handleNewGoalkeeperClear = (): void => {
        const { event, updateEvent } = this.props;

        const gk = event.goalkeeperChange;
        if (!gk) return;

        const updatedEvent = new UpdateEventCommand({
            ...event,
            goalkeeperChange: new GoalkeeperChangeRequest({
                ...gk,
                newGoalkeeperMatchPlayerId: 0,
            }),
        });

        updatedEvent.id = event.id;
        updateEvent(updatedEvent);
    };

    public render = (): React.ReactElement => {
        const { event, lineups, homeTeamId, clearEvent, deleteEvent, events } = this.props;
        const eventVm = event as EventVm;
        const eventExists = !!eventVm.id;

        const teamId = getTeamId(event);
        const isHomeTeam = teamId === homeTeamId;
        const teamLineups = lineups.filter(
            (l: CreateMatchPlayerCommandOfMatchPlayer): boolean => l.teamId === teamId
        );
        const gkChangeDisabledCaps = getFieldPlayIneligibleCapNumbers(events, teamLineups);

        const newGkLineup = lineups.find(
            (l) => l.id === event.goalkeeperChange?.newGoalkeeperMatchPlayerId
        );
        const prevGkLineup = lineups.find(
            (l) => l.id === event.goalkeeperChange?.previousGoalkeeperMatchPlayerId
        );

        const capClass = `c-shot-form__cap-selector c-shot-form__cap-selector--${
            isHomeTeam ? 'home' : 'away'
        }`;
        const isStartingGoalkeeper = !event.goalkeeperChange?.previousGoalkeeperMatchPlayerId;

        return (
            <div className="event-create match-form-lineup">
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                    }}
                >
                    <div className="title" style={{ fontSize: 16, marginBottom: 10 }}>
                        {isStartingGoalkeeper ? 'Starting goalkeeper' : 'Goalkeeper change'} —{' '}
                        {isHomeTeam ? 'White' : 'Blue'} team
                    </div>
                    <div className="c-shot-form__actions">
                        <span
                            className="c-shot-form__action-btn"
                            onClick={(): void => clearEvent()}
                            role="button"
                            title="Close"
                        >
                            <Icon name="icon-times" />
                        </span>
                        {eventExists && (
                            <Popconfirm
                                title="Are you sure you want to delete this event?"
                                onConfirm={(): void => deleteEvent(eventVm)}
                                okText="Delete"
                                okButtonProps={{ danger: true }}
                                cancelText="Cancel"
                            >
                                <span
                                    className="c-shot-form__action-btn c-shot-form__action-btn--delete"
                                    role="button"
                                    title="Delete"
                                >
                                    <DeleteOutlined />
                                </span>
                            </Popconfirm>
                        )}
                    </div>
                </div>
                {prevGkLineup && (
                    <div style={{ marginBottom: 10, color: '#ffffff' }}>
                        Previous goalkeeper:{' '}
                        <strong>#{prevGkLineup.capNumber || prevGkLineup.number}</strong>
                    </div>
                )}
                <div className="title">Select new goalkeeper:</div>
                <CapSelector
                    capClass={capClass}
                    onSelect={this.handleNewGoalkeeperSelect}
                    onClear={this.handleNewGoalkeeperClear}
                    caps={teamLineups.map(
                        (l: CreateMatchPlayerCommandOfMatchPlayer): CapNumber => ({
                            cap: l.number,
                            capNumber: l.capNumber || l.number,
                        })
                    )}
                    activeCap={newGkLineup ? newGkLineup.number : null}
                    activeCapNumber={
                        newGkLineup ? newGkLineup.capNumber || newGkLineup.number : null
                    }
                    disabledCaps={gkChangeDisabledCaps}
                />
            </div>
        );
    };
}

export default GoalkeeperChange;
